






















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Designer } from '../../types/designers'
import { Dress, generateEmptyDress } from '../../types/dresses'
import { getDesigner } from '../../utils/http-client/designer-api'
import DesignerForm from '../../components/DesignerComponents/DesignerForm.vue'
import DressCard from '../../components/DressComponents/DressCard.vue'
import DressForm from '../../components/DressComponents/DressForm.vue'
import UserBus from '@/utils/buses/UserBus'

@Component({
  components: {
    DesignerForm,
    DressCard,
    DressForm
  }
})
export default class DesignerView extends Vue {
  private isLoading: boolean = false
  private error: string = ''
  private openDesignerForm: boolean = false
  private designer: Designer | null = null
  private dresses: Dress[] = []
  private openDressForm: boolean = false
  private dress: Dress = generateEmptyDress()
  private canUpdate: boolean = false

  async created () {
    this.isLoading = true
    await this.readDesigner()
    this.isLoading = false
  }

  mounted () {
    this.setPermissions()
    UserBus.$on('user-update', this.setPermissions)
  }
  beforeDestroy () {
    // remove event listener to prevent memory leaks
    UserBus.$off('user-update', this.setPermissions)
  }

  async readDesigner () {
    const designerId = Number(this.$route.params.id)
    const res = await getDesigner(designerId)

    this.designer = res.designer
    this.dresses = res.dresses
  }

  // TODO - find better way to handle permissions. (less boilerplate)
  // for example maybe a computed property called canUpdate that auto updates when the user gets updated
  private setPermissions () {
    const designerId = Number(this.$route.params.id)
    this.canUpdate = UserBus.userIsDesigner(designerId)
  }
}
